import { render, staticRenderFns } from "./InvitacionesCopiadas.vue?vue&type=template&id=7e48b93e"
import script from "./InvitacionesCopiadas.vue?vue&type=script&lang=js"
export * from "./InvitacionesCopiadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports